import httpClient from "./httpClient";
import type { UserDetails, User } from "../types/users";

export const user = {
	config: async (id: number) => {
		const response = await httpClient.get(`/users/${id}/config`);
		return response.data;
	},
	refresh: async (): Promise<UserDetails | undefined> => {
		const response = await httpClient.get(`/users/details`);
		return response.data as UserDetails;
	},
	update: async (user: User): Promise<UserDetails | undefined> => {
		const response = await httpClient.put(`/users/current/profile`, user);
		return response.data as UserDetails;
	},
	updatePassword: async (id: number, password: string): Promise<undefined> => {
		if (!id || !password) return undefined;
		const response = await httpClient.post(`/users/${id}/password`, {
			password
		});
		return response.data as undefined;
	}
};
